// Placeholder shapes that match the real cards, so loading does not collapse
// the layout or flash an empty grid.

export function CatalogGridSkeleton({ count = 6 }) {
  return Array.from({ length: count }, (_, index) => (
    <div key={index} className="catalog-card is-skeleton" aria-hidden="true">
      <div className="catalog-card-image">
        <div className="skeleton-block" />
      </div>
      <div className="catalog-card-body">
        <div className="skeleton-line short" />
        <div className="skeleton-line" />
        <div className="skeleton-line medium" />
      </div>
    </div>
  ));
}

export function ProductSkeleton() {
  return (
    <section className="product-feature is-active-product section-pad is-skeleton" aria-hidden="true">
      <div className="product-gallery">
        <div className="skeleton-block tall" />
      </div>
      <div className="product-summary">
        <div className="skeleton-line short" />
        <div className="skeleton-line tall-line" />
        <div className="skeleton-line" />
        <div className="skeleton-line medium" />
      </div>
    </section>
  );
}

export function PageLoader({ label }) {
  return (
    <div className="page-loader" role="status">
      <span className="page-loader-mark" aria-hidden="true" />
      <p>{label}</p>
    </div>
  );
}
